var $fd928d81cf33984c$exports = {};
$fd928d81cf33984c$exports = {
    "alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


export {$fd928d81cf33984c$exports as default};
//# sourceMappingURL=he-IL.module.js.map
